import { createTheme } from "@mui/material/styles";

// Define the Airbnb-style theme
export const Theme = createTheme({
    palette: {
        primary: {
            main: "#FF385C", // Airbnb Red-Pink
            contrastText: "#FFFFFF",
        },
        secondary: {
            main: "#222222", // Dark Gray
        },
        background: {
            default: "#FFFFFF", // Clean White Background
            paper: "#F7F7F7", // Light Gray
        },
        text: {
            primary: "#222222", // Dark Gray
            secondary: "#717171", // Muted Gray
        },
    },
    typography: {
        fontFamily: `"Airbnb Cereal", "Poppins", "Arial", sans-serif`,
        h1: {
            fontSize: "2.5rem",
            fontWeight: 600,
        },
        h2: {
            fontSize: "2rem",
            fontWeight: 500,
        },
        h3: {
            fontSize: "1.75rem",
            fontWeight: 500,
        },
        body1: {
            fontSize: "1rem",
            color: "#222222",
        },
        button: {
            textTransform: "none",
            fontWeight: 500,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    transition: "all 0.3s ease",
                    borderRadius: "8px",
                    fontWeight: "bold",
                    padding: "10px 20px",
                    backgroundColor: "#FF385C",
                    color: "#FFFFFF",
                    boxShadow: "none",
                    "&:hover": {
                        backgroundColor: "#D7044E",
                    },
                "&.Mui-disabled": {
                  backgroundColor: "#B0B0B0",
                  color: "#FFFFFF",
                  opacity: 0.6,
                },
                },
                outlined: {
                    border: "1px solid #DDDDDD",
                    color: "#222222",
                    backgroundColor: "#FFFFFF",
                    "&:hover": {
                        backgroundColor: "#F7F7F7",
                    },
                },
            },
        },
        // MuiCard: {
        //     styleOverrides: {
        //         root: {
        //             background: "#FFFFFF",
        //             borderRadius: "12px",
        //             boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        //             border: "1px solid #DDDDDD",
        //             "&:hover": {
        //                 border: "1px solid #222222",
        //             },
        //         },
        //     },
        // },
    },
});